import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { UserState } from '../../shared/user-state/user.state';

@Injectable({
  providedIn: 'root',
})
export class ShowIntroGuardService implements CanActivate {
  private router = inject(Router);
  private store = inject(Store);

  canActivate(): boolean {
    const introViewed = this.store.selectSnapshot(UserState.introViewed);
    if (!introViewed) {
      this.router.navigateByUrl('/intro').then();
      return false;
    }
    return true;
  }
}
